import { render, staticRenderFns } from "./iconSvg.vue?vue&type=template&id=cfcacc04&scoped=true"
import script from "./iconSvg.vue?vue&type=script&lang=js"
export * from "./iconSvg.vue?vue&type=script&lang=js"
import style0 from "./iconSvg.vue?vue&type=style&index=0&id=cfcacc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcacc04",
  null
  
)

export default component.exports